import React from "react";
import { Image } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import dummyImage from "../../../assets/images/global_icons/dummyimage.svg";
import baseURL from "../../../utils/constants/baseUrl";
import { useState, useRef } from "react";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import { useAtom } from "jotai";
import { mobileViewCheck } from "../../../utils/store";
import ShareModal from "../../Modals/ShareModal";
import Edit from "../../../assets/images/global_icons/edit.svg";
import Share from "../../../assets/images/global_icons/share.svg";
import Export from "../../../assets/images/global_icons/export.svg";
import Delete from "../../../assets/images/global_icons/delete.svg";
import ActionMenu from "../../../assets/images/global_icons/action-menu.svg";
import { AiOutlineEye } from "react-icons/ai";

const ListView = ({ contacts, handleDelete, handleExportCollection }) => {
  const [shareOpen, setShareOpen] = useState(false);
  const [uuid, setUuid] = useState("");
  const [show, setShow] = useState(false);
  const [mobileView] = useAtom(mobileViewCheck);

  const target = useRef(null);

  const handleShareOpen = (contact_uuid) => {
    setShareOpen(true);
    setUuid(contact_uuid);
  };

  const handleShareClose = () => {
    setShareOpen(false);
    setUuid("");
    setShow(false);
  };

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Name",
      width: "30%",
      cell: (row) => (
        <div className="profileWrapper">
          <Image
            src={`${baseURL.PUBLIC_URL}${row.profile_image}` || dummyImage}
            // roundedCircle={true}
            style={{ borderRadius: "8px" }}
            loading="lazy"
            decoding="async"
            width="50px"
            height="50px"
            onError={(e) => {
              e.currentTarget.src = dummyImage;
            }}
          />
          <div>
            <p className="globalName">
              {row.first_name} {row.last_name}
            </p>
            <p className="globalDetail">{row.description}</p>
          </div>
        </div>
      ),
    },
    // {
    //   name: "Number",
    //   width: "20%",
    //   cell: (row) => (
    //     <div className={"globalNumber"}>
    //       {formatPhoneNumber(row.country_phone + row.phone_number) || "-"}
    //       {/* {`${row.country_phone ? `+${row.country_phone}` : ""}${
    //         row.phone_number || "-"
    //       }`} */}
    //     </div>
    //   ),
    // },
    {
      name: "Address",
      cell: (row) => {
        const addressParts = [];
        if (row.address) addressParts.push(row.address);
        if (row.city) addressParts.push(row.city);
        if (row.state) addressParts.push(row.state);
        if (row.country) addressParts.push(row.country);
        const fullAddress = addressParts.join(", ");

        return (
          <>
            {fullAddress ? (
              <a
                className={"detailInput"}
                href={`http://maps.google.com/?q=${encodeURIComponent(fullAddress)}`}
                target="_blank"
                rel="noreferrer"
              >
                {row.address ? (
                  <span>
                    {row.address}
                    <br />
                    {addressParts.slice(1).join(", ")}
                  </span>
                ) : (
                  fullAddress
                )}
              </a>
            ) : (
              <p className="globalDetail">-</p>
            )}
          </>
        );
      },
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className="action dropstart">
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img className={"globalVerticalThreeDots"} src={ActionMenu}></img>
            {/* <BsThreeDotsVertical className={"globalVerticalThreeDots"}  /> */}
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                to={`/contacts/viewcontact/${row.contact_id}`}
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <AiOutlineEye />
                View
              </Link>
            </li>
            {row.is_manual ? (
              <li>
                <Link
                  className="dropdown-item"
                  to={`/contacts/${row.contact_id} `}
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  {" "}
                  <img src={Edit}></img>
                  Edit
                </Link>
              </li>
            ) : null}

            <li>
              <span
                className="dropdown-item"
                onClick={() => handleShareOpen(row.uuid)}
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                {" "}
                <img src={Share}></img>
                Share
              </span>
            </li>

            <li>
              <button
                className="dropdown-item"
                onClick={() => handleExportCollection(row.contact_id)}
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <img
                  src={Export}
                  style={{ width: "16px", height: "16px" }}
                ></img>
                Export Collection
              </button>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                onClick={() => handleDelete(row.contact_id)}
                style={{
                  color: "var(--error_color)",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <img
                  src={Delete}
                  alt="Delete"
                  style={{ width: "16px", height: "16px" }}
                />
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="">
        <div className="default-list-table">
          {contacts.length === 0 ? (
            <div className="text-center my-4">
              <p>No data found</p>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={contacts}
              theme="solarized"
              responsive={true}
              noDataComponent="No record found" //or your component
            />
          )}
        </div>
      </div>

      {shareOpen && (
        <ShareModal
          target={target}
          shareOpen={shareOpen}
          handleShareClose={handleShareClose}
          setShowCopyPopup={setShow}
          functionType="contact"
          functionUuid={uuid}
        />
      )}

      <Overlay
        target={target.current}
        show={show}
        placement={mobileView ? "left" : "right"}
      >
        {(props) => (
          <Tooltip id="overlay-example" {...props}>
            Link Copied
          </Tooltip>
        )}
      </Overlay>
    </>
  );
};

export default ListView;
